import { render } from "./ActivityLog.vue?vue&type=template&id=7f45ea02"
import script from "./ActivityLog.vue?vue&type=script&lang=js"
export * from "./ActivityLog.vue?vue&type=script&lang=js"
script.render = render

export default script